import { compose } from 'ramda';

import { saveReturnPath } from '#src/store/location/actions';

import { anonymousOnly } from '../guards';

export const path = '/login';
export const component = 'Login';

export const thunk = () => (dispatch, getState) => {
  if (anonymousOnly(dispatch, getState)) return;
  compose(dispatch, saveReturnPath)();
};
